import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useField } from 'formik';
import ReactSelect from 'react-select';

import Error from '@components/form/error';

export default function Select({
  label: fieldLabel, options, defaultValue, selectProps, ...props
}) {
  const [field, meta, helpers] = useField(props);

  const classes = useMemo(() => classNames(
    'input__wrapper',
    { error: meta.touched && !!meta.error },
    { 'input__wrapper--filled': !!field.value },
  ), [field, meta]);

  return (
    <div className={classes}>
      <label>
        <span className='input__wrapper__label'>{fieldLabel}</span>
        <div className='input__wrapper__input'>
          <ReactSelect
            {...field}
            value={
              defaultValue
                ? field.value
                : options.find((i) => i.value === field.value) ?? null
            }
            isClearable
            options={options}
            onChange={
              defaultValue
                ? helpers.setValue
                : (input) => (
                  helpers.setValue(input?.value ?? '')
                )
            }
            classNamePrefix='react-select'
            {...selectProps}
          />
        </div>
        <Error name={field.name} />
      </label>
    </div>
  );
}

Select.defaultProps = {
  label: '',
  selectProps: {},
  defaultValue: false,
};

Select.propTypes = {
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.bool,
  label: PropTypes.string,
  selectProps: PropTypes.object,
};
